import * as React from "react";
import type { SVGProps } from "react";
const SvgSliders = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M6 12.172V3c0-.55-.45-1-1-1s-1 .45-1 1v9.172A3.012 3.012 0 0 0 2 15c0 1.3.838 2.413 2 2.828V21c0 .55.45 1 1 1s1-.45 1-1v-3.172A3.012 3.012 0 0 0 8 15c0-1.3-.838-2.413-2-2.828ZM5 14c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1ZM20 3v9.172c1.162.415 2 1.528 2 2.828 0 1.3-.838 2.413-2 2.828V21c0 .55-.45 1-1 1s-1-.45-1-1v-3.172A3.012 3.012 0 0 1 16 15c0-1.3.838-2.413 2-2.828V3c0-.55.45-1 1-1s1 .45 1 1Zm-2 12c0-.55.45-1 1-1s1 .45 1 1-.45 1-1 1-1-.45-1-1ZM12 22c-.55 0-1-.45-1-1v-9.172A3.012 3.012 0 0 1 9 9c0-1.3.838-2.413 2-2.828V3c0-.55.45-1 1-1s1 .45 1 1v3.172C14.162 6.587 15 7.7 15 9c0 1.3-.838 2.413-2 2.828V21c0 .55-.45 1-1 1Zm0-12c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgSliders;
